
import relatedService from 'player/services/api/related';
import Asset from '../asset';

// eslint-disable-next-line
const mapResponse = (vendor, assets) => assets.map((asset) => {
    // add vendor to assets
    return new Asset(Object.assign({
        vendor
    }, asset));
});

/**
 * @param {string} vendor
 * @param {number} assetId
 * @returns {Promise<unknown>}
 */
async function fetchFromRelated({ vendor, assetId }) {
    const assets = await relatedService.getRelatedAssets({ vendor, assetId });
    return mapResponse(vendor, assets);
}

export default {
    fetchFromRelated
};
